import React from "react";
import {capitalizeFirstLetter} from "../../../helpers/stringHelper";
import {Tag} from "../../../components/table/Status";
import Male from "../../../assets/avatar/male_doc.svg";

function ConsultationItem({doctor}) {
  return (
    <div className="w-full p-3 border bg-white space-x-2 rounded-md flex items-center mb-2">
      <div className="rounded-full border h-16 w-16 bg-white shrink-0 overflow-hidden">
        <img
          src={Male}
          alt="images" className="h-full w-full object-contain"/>
      </div>
      <div className="w-full">
        <div className="mb-2 font-medium">{capitalizeFirstLetter(doctor.first_name) + " " + capitalizeFirstLetter(doctor.last_name)}</div>
       <div className="flex flex-wrap">
         {
           doctor.speciality.map((s)=><Tag label={capitalizeFirstLetter(s)}/>)
         }
       </div>

      </div>
    </div>
  )
}

export default ConsultationItem